import React from 'react';
import classes from './Select.module.css';
import nextId from 'react-id-generator';
import { string, number, func, arrayOf, shape } from 'prop-types';

const Select = ({ label, value, onChange, options }) => {
  const htmlFor = `${label}-${~~Math.random()}`

  return (
    <div className={classes.select}>
      <label htmlFor={htmlFor}>{label}</label>
      <select
        id={htmlFor}
        value={value}
        onChange={onChange}
      >
        {options.map(({ value, text }) => {
          return (
            <option
              value={value}
              key={nextId()}
            >
              {text}
            </option>
          )
        })}
      </select>
    </div>
  )
}

Select.propTypes = {
  label: string,
  value: number,
  onChange: func,
  options: arrayOf(
    shape({
      text: number,
      value: number,
    })
  ).isRequired,
}

Select.defaultProps = {
  label: '',
  value: 0,
  onChange: () => { },
  options: arrayOf(
    shape({
      text: 0,
      value: 0,
    })
  )
}

export default Select